
export class IQFlexWorkloadDTO
{
    public displayWorkload : boolean;
    public waitingCustomerCount : number;
    public avgWaitTime : number;
    public color : string;
}